import React, { createContext, useContext } from "react";

const TranslationContext = createContext({
  translationEnabled: false,
  translationConfigured: false,
  translationLoading: false,
  agentLanguage: "pt",
  customerLanguage: "fr",
  toggleTranslation: async () => {},
  setAgentLanguage: async () => {},
  setCustomerLanguage: async () => {},
});

export const useTranslation = () => useContext(TranslationContext);

export default TranslationContext;
